import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Settings from '../components/Settings';

const SettingsPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-emerald-600 mb-2">تەڭشەكلەر</h1>
          <p className="text-gray-600 uyghur-text">ئويۇن تەڭشەكلىرىنى بەلگىلەڭ</p>
        </div>
        
        <Settings />
      </main>
      
      <Footer />
    </div>
  );
};

export default SettingsPage;